import { useNavigate } from 'react-router-dom';
import { Star } from 'lucide-react';
import { patientPath } from '../constants/routes';
import { getPatientDisplayName } from '../constants/mockPatients';
import { useLanguage } from '../contexts/LanguageContext';
import { translateWard } from '../i18n/translations';

export default function PatientListCard({
  patient,
  favorite,
  onToggleFavorite,
}) {
  const navigate = useNavigate();
  const { t, language } = useLanguage();
  const displayName = getPatientDisplayName(patient, language);
  const initial = displayName.charAt(0).toUpperCase();

  return (
    <div
      className="card-surface flex items-center gap-3 p-3 transition-colors hover:border-primary-ring"
      role="button"
      tabIndex={0}
      onClick={() => navigate(patientPath(patient.id))}
      onKeyDown={(e) => e.key === 'Enter' && navigate(patientPath(patient.id))}
    >
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 border-primary-mid bg-primary-light/50 text-sm font-bold text-primary">
        {initial}
      </div>

      <div className="min-w-0 flex-1">
        <p className="truncate text-[15px] font-bold text-gray-900" dir="auto">
          {displayName}
        </p>
        <p className="text-xs text-gray-500">
          {t('room')} {patient.room}
        </p>
        <p className="text-xs text-gray-500">{translateWard(t, patient.ward)}</p>
      </div>

      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onToggleFavorite(patient.id);
        }}
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full"
        aria-label={favorite ? t('removeFavorite') : t('addFavorite')}
      >
        <Star
          className={`h-4 w-4 ${favorite ? 'fill-favorite text-favorite' : 'text-gray-300'}`}
          strokeWidth={2}
        />
      </button>
    </div>
  );
}
